const items = ["AUTONOMOUS AI", "CLOUD ARCHITECTURE", "HIGH-CONCURRENCY SYSTEMS", "MULTICLOUD INTEGRATION", "TECHNICAL STORYTELLING", "FULL-STACK DELIVERY", "CUSTOMER DISCOVERY"];

function EditorialMarquee() {
  const loop = [...items, ...items];
  return (
    <section className="marquee-section" aria-label="Areas of expertise" data-testid="editorial-ticker-marquee">
      <div className="marquee-window">
        <div className="marquee-track">
          {loop.map((item, index) => <span key={`${item}-${index}`} data-testid={index === 0 ? "editorial-ticker-item" : undefined}>{item}<b>—</b></span>)}
        </div>
      </div>
    </section>
  );
}

export default EditorialMarquee;
